import React from "react";
import GridHeader from "./Grid/GridHeader";
import { Alert, Container } from "reactstrap";
import GridBody from "./Grid/GridBody";
import withRouter from "../../components/Common/withRouter";
import { useSelector } from "react-redux";
import { DF_LO0012Context } from "./context";

function DF_LO0012(props) {
  document.title = "Defender | Anulação Validação Documento de Transporte";

  const { isModalPage } = useSelector((state) => ({
    isModalPage: state.Layout.isModalPage,
  }));

  const location = props.router.location;
  const parseParams = new URLSearchParams(location.search);

  if (!parseParams.get("ID_Arquivo")) {
    return (
      <Alert color="danger">
        Não é possível acessar essa transação sem parametros
      </Alert>
    );
  }

  return (
    <DF_LO0012Context.Provider
      value={{
        parseParams,
      }}
    >
      <div
        className="page-content"
        {...(isModalPage && { style: { padding: "0px", overflow: "hidden" } })}
      >
        <Container fluid={true}>
          <GridHeader />
          <GridBody />
        </Container>
      </div>
    </DF_LO0012Context.Provider>
  );
}

export default withRouter(DF_LO0012);
